<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone direita"><button @click="criarProtocolo()"
                    :disabled="tipo == 8 ? !funcionalidades.includes(257) : false"
                    :title="tipo == 8 ? !funcionalidades.includes(257) ? 'Você não tem permissão para criação de PAP' : '' : ''"
                    :style="tipo == 8 ? !funcionalidades.includes(257) ? { cursor: 'not-allowed' } : {} : {}"
                    class="acao-secundaria">Adicionar</button>
            </div>
            <div class="m-icone direita">
                <div class="pesquisa">
                    <input type="text" placeholder="Pesquisar" v-model="search" @input="aplicarBusca()" />
                    <a disabled class="icone-pesquisa"></a>
                </div>
            </div>
            <h2>{{ tipoPorExtenso }}</h2>
        </div>
    </div>
    <div class="margem container">
        <div class="bloco margem">

            <div v-if="funcionalidades.includes(208)" class="m-icone direita"><button type="button"
                    @click="exportarExcel" class="acao-secundaria">Exportar Excel</button></div>

            <table class="tabela">
                <tbody>
                    <tr>
                        <th class="desc">Código</th>
                        <th>
                            <div class="alinha-v">
                                <span>
                                    Criador
                                </span>
                                <v-menu :close-on-content-click="false">
                                    <template v-slot:activator="{ props }">
                                        <span class="mdi mdi-filter-variant fonte-maior icone"
                                            :class="{ 'ativo': !filtroCriadorAtivo }" v-bind="props"></span>
                                    </template>
                                    <v-list>
                                        <v-list-item>
                                            <ul class="lista">
                                                <li v-for="g, index in criadores" :key="index">
                                                    <span class="alinha-v" v-if="g.nome">
                                                        <input type="checkbox" @change="filtrarProtocolos()" :id="index"
                                                            v-model="filtros.criador" :value="g.id"><label
                                                            style="margin-bottom: 0" :for="index">
                                                            {{ g.nome }}</label>
                                                    </span>
                                                </li>
                                            </ul>
                                            <div class="alinha-centro" style="padding-block: .5rem;">
                                                <span style="cursor: pointer" class="chip bg-cinza"
                                                    @click="filtros.criador = [], filtrarProtocolos()">
                                                    Limpar Lista
                                                </span>
                                                <span style="cursor: pointer" class="chip bg-ok"
                                                    @click="filtros.criador = criadores.map(i => i.id), filtrarProtocolos()">
                                                    Selecionar Todos
                                                </span>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </th>
                        <th class="desc">
                            Descrição
                        </th>
                        <th>
                            <div class="alinha-v">
                                <span>
                                    Status
                                </span>
                                <v-menu :close-on-content-click="false">
                                    <template v-slot:activator="{ props }">
                                        <span class="mdi mdi-filter-variant fonte-maior icone"
                                            :class="{ 'ativo': !(['Pendente', 'Em andamento', 'Concluído'].every(v => filtros.status.includes(v))) }"
                                            v-bind="props"></span>
                                    </template>
                                    <v-list>
                                        <v-list-item>
                                            <div style="display: flex; flex-flow: column; gap: .5rem;">
                                                <div class="alinha-v">
                                                    <input type="checkbox" @change="filtrarProtocolos()" id="Pendente"
                                                        v-model="filtros.status" :value="'Pendente'">
                                                    <label for="Pendente" style="margin-bottom: 0">
                                                        A iniciar</label>
                                                </div>
                                                <div class="alinha-v">
                                                    <input type="checkbox" @change="filtrarProtocolos()" id="andamento"
                                                        v-model="filtros.status" :value="'Em andamento'">
                                                    <label for="andamento" style="margin-bottom: 0">Em
                                                        andamento</label>
                                                </div>
                                                <div class="alinha-v">
                                                    <input type="checkbox" @change="filtrarProtocolos()" id="concluido"
                                                        v-model="filtros.status" :value="'Concluído'">
                                                    <label for="concluido" style="margin-bottom: 0;">Concluído</label>
                                                </div>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </th>
                        <th>
                            <div class="alinha-v">
                                <span>
                                    Data da Criação
                                </span>
                                <v-menu :close-on-content-click="false">
                                    <template v-slot:activator="{ props }">
                                        <span class="mdi mdi-filter-variant fonte-maior icone" v-bind="props"
                                            :class="{ 'ativo': (filtros.dtInicio.de || filtros.dtInicio.ate) }"></span>
                                    </template>

                                    <v-list>
                                        <v-list-item>
                                            <v-list-item-title>
                                                Período
                                            </v-list-item-title>
                                            <div class="alinha-v" style="gap: .5rem;">
                                                <input type="date" v-model="filtros.dtInicio.de"
                                                    @change="filtrarProtocolos()"> até
                                                <input type="date" @change="filtrarProtocolos()"
                                                    v-model="filtros.dtInicio.ate">
                                            </div>
                                            <div class="alinha-centro" style="padding-block: .5rem;">
                                                <span style="cursor: pointer" class="chip bg-cinza"
                                                    @click="filtros.dtInicio = { de: '', ate: '' }, filtrarProtocolos()">
                                                    Limpar
                                                </span>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </th>
                        <th>
                            Prazo
                        </th>
                        <th>
                            <div class="alinha-v">
                                <span>
                                    Fim Previsto
                                </span>
                                <v-menu :close-on-content-click="false">
                                    <template v-slot:activator="{ props }">
                                        <span class="mdi mdi-filter-variant fonte-maior icone" v-bind="props"
                                            :class="{ 'ativo': (filtros.dtFimPrev.de || filtros.dtFimPrev.ate) }"></span>
                                    </template>

                                    <v-list>
                                        <v-list-item>
                                            <v-list-item-title>
                                                Período
                                            </v-list-item-title>
                                            <div class="alinha-v" style="gap: .5rem;">
                                                <input type="date" v-model="filtros.dtFimPrev.de"
                                                    @change="filtrarProtocolos()"> até
                                                <input type="date" @change="filtrarProtocolos()"
                                                    v-model="filtros.dtFimPrev.ate">
                                            </div>
                                            <div class="alinha-centro" style="padding-block: .5rem;">
                                                <span style="cursor: pointer" class="chip bg-cinza"
                                                    @click="filtros.dtFimPrev = { de: '', ate: '' }, filtrarProtocolos()">
                                                    Limpar
                                                </span>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </th>
                        <th>
                            <div class="alinha-v">
                                <span>
                                    Responsável
                                </span>
                                <v-menu :close-on-content-click="false">
                                    <template v-slot:activator="{ props }">
                                        <span class="mdi mdi-filter-variant fonte-maior icone"
                                            :class="{ 'ativo': !filtroResponsavelAtivo }" v-bind="props"></span>
                                    </template>
                                    <v-list>
                                        <v-list-item>
                                            <ul class="lista">
                                                <li v-for="g, index in responsaveis" :key="index">
                                                    <span class="alinha-v" v-if="g.nome">
                                                        <input type="checkbox" @change="filtrarProtocolos()" :id="index"
                                                            v-model="filtros.responsavel" :value="g.id"><label
                                                            style="margin-bottom: 0" :for="index">
                                                            {{ g.nome }}</label>
                                                    </span>
                                                </li>
                                            </ul>
                                            <div class="alinha-centro" style="padding-block: .5rem;">
                                                <span style="cursor: pointer" class="chip bg-cinza"
                                                    @click="filtros.responsavel = [], filtrarProtocolos()">
                                                    Limpar Lista
                                                </span>
                                                <span style="cursor: pointer" class="chip bg-ok"
                                                    @click="filtros.responsavel = responsaveis.map(i => i.id), filtrarProtocolos()">
                                                    Selecionar Todos
                                                </span>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </th>
                        <th>
                            <div class="alinha-v">
                                <span>
                                    Setor Demandante
                                </span>
                                <v-menu :close-on-content-click="false">
                                    <template v-slot:activator="{ props }">
                                        <span class="mdi mdi-filter-variant fonte-maior icone"
                                            :class="{ 'ativo': !filtroSetorEnvolvidoAtivo }" v-bind="props"></span>
                                    </template>
                                    <v-list>
                                        <v-list-item>
                                            <ul class="lista">
                                                <li v-for="g, index in setoresEnvolvidos" :key="index">
                                                    <span class="alinha-v">
                                                        <input type="checkbox" @change="filtrarProtocolos()" :id="index"
                                                            v-model="filtros.setorEnvolvido" :value="g.id"><label
                                                            style="margin-bottom: 0" :for="index">
                                                            {{ g.nome }}</label>
                                                    </span>
                                                </li>
                                            </ul>
                                            <div class="alinha-centro" style="padding-block: .5rem;">
                                                <span style="cursor: pointer" class="chip bg-cinza"
                                                    @click="filtros.setorEnvolvido = [], filtrarProtocolos()">
                                                    Limpar Lista
                                                </span>
                                                <span style="cursor: pointer" class="chip bg-ok"
                                                    @click="filtros.setorEnvolvido = setoresEnvolvidos.map(i => i.id), filtrarProtocolos()">
                                                    Selecionar Todos
                                                </span>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </th>
                        <th>
                            <div class="alinha-v">
                                <span>
                                    Setor Destinatário
                                </span>
                                <v-menu :close-on-content-click="false">
                                    <template v-slot:activator="{ props }">
                                        <span class="mdi mdi-filter-variant fonte-maior icone"
                                            :class="{ 'ativo': !filtroSetorDestinatarioAtivo }" v-bind="props"></span>
                                    </template>
                                    <v-list>
                                        <v-list-item>
                                            <ul class="lista">
                                                <li v-for="g, index in setoresDestinatarios" :key="index">
                                                    <span class="alinha-v">
                                                        <input type="checkbox" @change="filtrarProtocolos()" :id="index"
                                                            v-model="filtros.setorDestinatario" :value="g.id"><label
                                                            style="margin-bottom: 0" :for="index">
                                                            {{ g.nome }}</label>
                                                    </span>
                                                </li>
                                            </ul>
                                            <div class="alinha-centro" style="padding-block: .5rem;">
                                                <span style="cursor: pointer" class="chip bg-cinza"
                                                    @click="filtros.setorDestinatario = [], filtrarProtocolos()">
                                                    Limpar Lista
                                                </span>
                                                <span style="cursor: pointer" class="chip bg-ok"
                                                    @click="filtros.setorDestinatario = setoresDestinatarios.map(i => i.id), filtrarProtocolos()">
                                                    Selecionar Todos
                                                </span>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </th>
                    </tr>
                    <tr style="text-align: center;" v-for="item in listaProtocolosFiltrada" :key="item.id"
                        @click="verProtocolo(item.id)">
                        <td>
                            {{ item.codigo }}
                        </td>
                        <td class="desc" style="vertical-align: middle">
                            {{ item.criador ?? '-' }}
                        </td>
                        <td class="desc">
                            {{ item.nome }}
                        </td>
                        <td @click.stop>
                            <div class="alinha-v alinha-centro">
                                <span style="white-space: nowrap; margin: 0 !important; font-size: 14px;" class="chip"
                                    :class="corStatus(item.status)">
                                    {{ item.status == 'Pendente' ? 'A iniciar' : item.status }}</span>
                            </div>
                        </td>
                        <td>
                            {{ formatarData(item.dtInicio) }}
                        </td>
                        <td>
                            <span class="chip" style="font-size: 14px; white-space: nowrap;"
                                :class="diasParaFim(item.status, item.dtFimPrevisto, item.dtFim).cor">
                                {{ diasParaFim(item.status, item.dtFimPrevisto, item.dtFim).mensagem }}
                            </span>
                        </td>
                        <td>
                            {{ formatarData(item.dtFimPrevisto) }}
                        </td>
                        <td class="desc">
                            {{ item.responsavel_nome }}
                        </td>
                        <td>
                            {{ item.setor?.nome ?? '-' }}
                        </td>
                        <td>
                            {{ item.setorDestinatario?.nome ?? '-' }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!protocolos" class="loading" id="loading">
                <div>
                </div>
            </div>
        </div>
    </div>
    <!-- abre somente se o tipo for RAP -->
    <ModalProtocolosFinalizar v-if="showModal && protocolosParaConclusao.length > 0 && tipo == 3"
        :protocolos="protocolosParaConclusao" @fechar="showModal = false" />
</template>
<script>
import { useApiError } from "@/composables/useApiError";
import serviceProtocolo from "@/services/serviceProtocolo";
import { sso } from "roboflex-thalamus-sso-lib";
import { getPermissao } from "@/services/permissao-service";
import { formatarDataBr } from "@/utils/date";
import ModalProtocolosFinalizar from "@/components/Modais/protocolos/ModalProtocolosFinalizar.vue";
import {
    montarChaveCacheLista,
    obterCacheLista,
    gravarCacheLista,
} from "@/utils/cacheListaMemoria";

export default {
    setup() {
        const { handleError } = useApiError();
        return {
            handleApiError: handleError,
            obterCacheLista,
            gravarCacheLista,
        };
    },
    name: "ControleProtocolo",

    components: {
        ModalProtocolosFinalizar
    },

    props: {
        tipo: {
            required: true
        },
    },

    watch: {
        tipo() {
            this.protocolos = [];
            this.restaurarFiltro();
            this.getProtocolos();
        }
    },

    computed: {
        protocolosParaConclusao() {
            if (!this.protocolos) {
                return []
            }
            return this.protocolos.filter(p => p.todas_tarefas_concluidas == true && p.responsavel_id == this.idUsuario && p.status != 'Concluído')
        },
        tipoPorExtenso() {
            var nome = ''
            switch (this.tipo) {
                case '1':
                    nome = 'Tratativa de Não Conformidade'
                    break;
                case '3':
                    nome = 'Resposta de Avaliação de Produto'
                    break;
                case '4':
                    nome = 'Ordem de Serviço'
                    break;
                case '5':
                    nome = 'Plano de Ação'
                    break;
                case '8':
                    nome = 'Plano de Alteração de Produto'
                    break;
                default:
                    nome = ''
            }
            return nome
        },

        criadores() {
            if (!this.protocolos) {
                return []
            }

            const mapa = new Map()

            this.protocolos.forEach(item => {
                if (!mapa.has(item.usuario_id)) {
                    mapa.set(item.usuario_id, {
                        id: item.usuario_id,
                        nome: item.criador
                    })
                }
            })

            return Array.from(mapa.values())
        },

        responsaveis() {
            if (!this.protocolos) {
                return []
            }
            const mapa = new Map()

            this.protocolos.forEach(item => {
                if (!mapa.has(item.responsavel_id)) {
                    mapa.set(item.responsavel_id, {
                        id: item.responsavel_id,
                        nome: item.responsavel_nome
                    })
                }
            })

            return Array.from(mapa.values())
        },

        setoresEnvolvidos() {
            if (!Array.isArray(this.protocolos)) return [];

            const mapa = new Map();

            for (const item of this.protocolos) {
                const s = item?.setor;
                if (!s || s.id == null) continue;

                const key = String(s.id);
                if (!mapa.has(key)) {
                    mapa.set(key, { id: s.id, nome: s.nome });
                }
            }

            return [...mapa.values()].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
        },

        setoresDestinatarios() {
            if (!Array.isArray(this.protocolos)) return [];

            const mapa = new Map(); // key = String(id) -> { id, nome }

            for (const item of this.protocolos) {
                const s = item?.setorDestinatario;
                if (!s || s.id == null) continue;

                const key = String(s.id);
                if (!mapa.has(key)) {
                    mapa.set(key, { id: s.id, nome: s.nome });
                }
            }

            // opcional: ordenar alfabeticamente
            return [...mapa.values()].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
        },

        filtroCriadorAtivo() {
            const selecionados = this.filtros.criador.map(String);
            const idsCriadores = this.criadores.map(g => String(g.id));

            if (selecionados.length !== idsCriadores.length) return false;

            return selecionados.every(id => idsCriadores.includes(id));
        },

        filtroResponsavelAtivo() {
            const selecionados = this.filtros.responsavel.map(String);
            const idsResponsaveis = this.responsaveis.map(g => String(g.id));

            if (selecionados.length !== idsResponsaveis.length) return false;

            return selecionados.every(id => idsResponsaveis.includes(id));
        },

        filtroSetorEnvolvidoAtivo() {
            const selecionados = this.filtros.setorEnvolvido.map(String);
            const idsSetores = this.setoresEnvolvidos.map(g => String(g.id));

            if (selecionados.length !== idsSetores.length) return false;

            return selecionados.every(id => idsSetores.includes(id));

        },

        filtroSetorDestinatarioAtivo() {
            const selecionados = this.filtros.setorDestinatario.map(String);
            const idsSetores = this.setoresDestinatarios.map(g => String(g.id));

            if (selecionados.length !== idsSetores.length) return false;

            return selecionados.every(id => idsSetores.includes(id));

        }
    },

    created() {
        const usuarioLogado = sso.getUsuarioLogado();
        this.idUsuario = usuarioLogado.id;
    },

    data() {
        return {
            idUsuario: null,
            showModal: true,
            protocoloEditado: {},
            listaProtocolosFiltrada: null,
            search: '',
            debounceBusca: null,
            requisicaoProtocolosSeq: 0,
            protocolos: null,
            tipoProtocolo: sessionStorage.getItem('tipoProtocolo'),
            funcionalidades: [],
            filtros: {
                status: ['Pendente', 'Em andamento'],
                criador: [],
                responsavel: [],
                setorEnvolvido: [],
                setorDestinatario: [],
                dtInicio: {
                    de: '',
                    ate: ''
                },
                dtFimPrev: {
                    de: '',
                    ate: ''
                }
            },
        }
    },

    async mounted() {
        this.restaurarFiltro();
        this.getProtocolos();
        this.funcionalidades = await getPermissao();
    },

    beforeUnmount() {
        clearTimeout(this.debounceBusca);
    },

    methods: {
        diasParaFim(status, dtFimPrevisto, dtFimReal) {
            const toLocalDateOnly = (val) => {
                if (!val) return null;

                if (val instanceof Date) {
                    return new Date(val.getFullYear(), val.getMonth(), val.getDate());
                }

                if (typeof val === 'string') {
                    const s = val.slice(0, 10);
                    const [y, m, d] = s.split('-').map(Number);
                    if (!y || !m || !d) return null;
                    return new Date(y, m - 1, d);
                }

                return null;
            };

            const fimPrevisto = toLocalDateOnly(dtFimPrevisto);
            const fimReal = toLocalDateOnly(dtFimReal);
            const agora = new Date();
            const hoje = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate());

            const st = (status || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
            const concluido = st === 'concluido';

            if (concluido) {
                if (!fimPrevisto) return { mensagem: 'Finalizado', cor: 'bg-sucesso' };

                if (!fimReal) return { mensagem: 'Finalizado', cor: 'bg-sucesso' };

                const diffDias = Math.round((fimPrevisto - fimReal) / 86400000);

                if (diffDias > 0) return { mensagem: `Finalizado ${diffDias} dia${diffDias > 1 ? 's' : ''} antes do prazo.`, cor: 'bg-sucesso' };
                if (diffDias === 0) return { mensagem: 'Finalizado no prazo.', cor: 'bg-sucesso' };
                return { mensagem: `Finalizado ${Math.abs(diffDias)} dia${Math.abs(diffDias) > 1 ? 's' : ''} atrasado.`, cor: 'bg-erro' };
            }

            if (!fimPrevisto) return { mensagem: 'Sem Previsão!', cor: 'bg-alerta' };

            const diffDias = Math.round((fimPrevisto - hoje) / 86400000);

            if (diffDias > 0) {
                if (diffDias <= 2) return { mensagem: `${diffDias} dia${diffDias > 1 ? 's restantes!' : ' restante!'}`, cor: 'bg-erro' };
                if (diffDias <= 5) return { mensagem: `${diffDias} dia${diffDias > 1 ? 's restantes!' : ' restante!'}`, cor: 'bg-alerta' };
                return { mensagem: `${diffDias} dia${diffDias > 1 ? 's restantes!' : 'restante!'}`, cor: 'bg-sucesso' };
            } else if (diffDias < 0) {
                return { mensagem: `${Math.abs(diffDias)} dia${Math.abs(diffDias) > 1 ? 's' : ''} de atraso!`, cor: 'bg-erro' };
            } else {
                return { mensagem: 'Hoje!', cor: 'bg-erro' };
            }
        },
        formatarData(data) {
            return formatarDataBr(data);
        },
        corStatus(cor) {
            switch (cor) {
                case 'Em andamento':
                    // return 'var(--cor-ok)';
                    return 'bg-ok';
                case 'Concluído':
                    // return 'var(--cor-sucesso)';
                    return 'bg-sucesso';
                default:
                    // return '#FFA500';
                    return 'bg-alerta';
            }
        },

        async exportarExcel() {
            try {
                await serviceProtocolo.downloadListaExcelPorTipo(this.tipo);
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async getProtocolos() {
            const seq = ++this.requisicaoProtocolosSeq;
            const chave = montarChaveCacheLista('controleProtocolo', {
                userId: this.idUsuario,
                tipo: String(this.tipo),
            });

            const aplicarLista = (data) => {
                this.protocolos = [...data].sort((a, b) => {
                    if (a.dtFimPrevisto && b.dtFimPrevisto) {
                        return new Date(a.dtFimPrevisto) - new Date(b.dtFimPrevisto);
                    }
                    if (a.dtFimPrevisto && !b.dtFimPrevisto) return -1;
                    if (!a.dtFimPrevisto && b.dtFimPrevisto) return 1;
                    if (a.codigo > b.codigo) return 1;
                    if (a.codigo < b.codigo) return -1;
                    return 0;
                });

                if (this.filtros.criador.length === 0) {
                    this.filtros.criador = this.criadores.map((i) => i.id);
                }
                if (this.filtros.responsavel.length === 0) {
                    this.filtros.responsavel = this.responsaveis.map((i) => i.id);
                }
                if (this.filtros.setorEnvolvido.length === 0) {
                    this.filtros.setorEnvolvido = this.setoresEnvolvidos.map((i) => i.id);
                }
                if (this.filtros.setorDestinatario.length === 0) {
                    this.filtros.setorDestinatario = this.setoresDestinatarios.map((i) => i.id);
                }

                this.filtrarProtocolos();
            };

            const cached = this.obterCacheLista(chave);
            if (cached) {
                if (seq !== this.requisicaoProtocolosSeq) return;
                aplicarLista(cached.protocolos);
                return;
            }

            try {
                const data = await serviceProtocolo.listarPorTipo(this.tipo);
                if (seq !== this.requisicaoProtocolosSeq) return;

                this.gravarCacheLista(chave, { protocolos: data });
                aplicarLista(data);
            } catch (error) {
                if (seq !== this.requisicaoProtocolosSeq) return;
                this.handleApiError(error);
            }
        },

        chaveStorageFiltro() {
            return `controleProtocoloFiltro:${this.tipo}`;
        },

        salvarFiltro() {
            try {
                sessionStorage.setItem(this.chaveStorageFiltro(), JSON.stringify({
                    search: this.search,
                    filtros: this.filtros,
                }));
            } catch {
                // Ignora falha de storage
            }
        },

        restaurarFiltro() {
            try {
                const raw = sessionStorage.getItem(this.chaveStorageFiltro());
                if (!raw) return;
                const salvo = JSON.parse(raw);
                if (salvo.search != null) this.search = salvo.search;
                if (salvo.filtros && typeof salvo.filtros === 'object') {
                    this.filtros = {
                        ...this.filtros,
                        ...salvo.filtros,
                        dtInicio: { ...this.filtros.dtInicio, ...(salvo.filtros.dtInicio || {}) },
                        dtFimPrev: { ...this.filtros.dtFimPrev, ...(salvo.filtros.dtFimPrev || {}) },
                    };
                }
            } catch {
                // Ignora filtro inválido
            }
        },

        aplicarBusca() {
            clearTimeout(this.debounceBusca);
            this.debounceBusca = setTimeout(() => {
                this.filtrarProtocolos();
            }, 300);
        },

        filtrarProtocolos() {
            if (!this.protocolos) {
                this.listaProtocolosFiltrada = [];
                return;
            }

            let lista = this.protocolos;

            lista = lista.filter(i => (this.filtros.criador.includes(i.usuario_id) || !i.usuario_id)
                && (this.filtros.responsavel.includes(i.responsavel_id) || !i.responsavel_id)
                && (this.filtros.status.includes(i.status) || !i.status)
                && (i.setor ? this.filtros.setorEnvolvido.includes(i.setor.id) : true)
                && (i.setorDestinatario ? this.filtros.setorDestinatario.includes(i.setorDestinatario.id) : true)
            );

            if (this.filtros.dtInicio.de) {
                lista = lista.filter(i => i.dtInicio >= this.filtros.dtInicio.de);
            }
            if (this.filtros.dtInicio.ate) {
                lista = lista.filter(i => i.dtInicio <= this.filtros.dtInicio.ate);
            }

            if (this.filtros.dtFimPrev.de) {
                lista = lista.filter(i => i.dtFimPrevisto >= this.filtros.dtFimPrev.de);
            }
            if (this.filtros.dtFimPrev.ate) {
                lista = lista.filter(i => i.dtFimPrevisto <= this.filtros.dtFimPrev.ate);
            }

            const termo = (this.search || '').trim().toLowerCase();
            if (termo) {
                lista = lista.filter(item => Object.values(item).some(value => {
                    if (typeof value === 'string') {
                        return value.toLowerCase().includes(termo);
                    }
                    if (typeof value === 'number') {
                        return value.toString().toLowerCase().includes(termo);
                    }
                    if (value && typeof value === 'object') {
                        return JSON.stringify(value).toLowerCase().includes(termo);
                    }
                    return false;
                }));
            }

            this.listaProtocolosFiltrada = lista;
            this.salvarFiltro();
        },

        criarProtocolo() {
            this.$router.push({ name: 'criacaoProtocolo', params: this.tipo })
        },

        verProtocolo(idProtocolo) {
            this.salvarFiltro();
            this.$router.push({ name: 'visualizacaoProtocolo', params: { idProtocolo } })
        }
    }

}
</script>

<style scoped>
th {
    div {
        justify-content: center;
        gap: 5px;
    }
}

.header {
    cursor: pointer;
}

.icone.ativo {
    border-bottom: 2px solid var(--cor-ok);
}

.desc {
    max-width: 15%;
    text-align: left;
}

.lista {
    list-style: none;
    margin: 0;
    padding-bottom: 1rem;
    padding-right: 1rem;
    max-height: 20rem;
    overflow: auto;

    li {
        margin-top: .5rem;
        border-bottom: 1px solid var(--cor-separador);
        padding-bottom: 4px;
        max-width: 14rem;
    }
}
</style>